import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { addSecurityHeaders } from './lib/securityUtils'
import { googleAdsCompliance } from './lib/googleAdsCompliance'

// Performance optimization: Use requestIdleCallback for non-critical tasks
const loadNonCriticalResources = () => {
  // Async load non-critical CSS
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = '/src/index.css';
  document.head.appendChild(link);
};

// Optimize loading sequence for LCP
if ('requestIdleCallback' in window) {
  requestIdleCallback(loadNonCriticalResources);
} else {
  setTimeout(loadNonCriticalResources, 1);
}

// Initialize enhanced security for Google Ads compliance (non-blocking)
addSecurityHeaders();

// Use setTimeout to make logging non-blocking for critical path
setTimeout(() => {
  // Log legitimate application startup
  googleAdsCompliance.logLegitimateActivity('application_startup', {
    event_type: 'legitimate_business_activity',
    component: 'main_application',
    compliance_note: 'Event planning application startup'
  });
}, 100);

createRoot(document.getElementById("root")!).render(<App />);
